import { type DashboardSpec, type PanelSpec, type StreamEntry } from "../ChartSpec";

export type DashboardSpecAction =
    | { type: "update"; payload: DashboardSpec }
    | { type: "update-panel"; payload: PanelSpec }
    | {
          type: "update-panel-stream";
          payload: { panelId: string; streamId: number; stream: Partial<StreamEntry> };
      };

// Single authoritative place for spec mutations — enforces referential integrity
// (e.g. panel/stream updates only touch their target, leaving siblings untouched).
export const specReducer = (state: DashboardSpec, action: DashboardSpecAction): DashboardSpec => {
    switch (action.type) {
        case "update":
            return action.payload;
        case "update-panel":
            return {
                ...state,
                panels: state.panels.map((panel) => (panel.id === action.payload.id ? action.payload : panel)),
            };
        case "update-panel-stream":
            return {
                ...state,
                panels: state.panels.map((panel) => {
                    if (panel.id !== action.payload.panelId) return panel;
                    return {
                        ...panel,
                        streams: panel.streams.map((stream) =>
                            stream.streamId === action.payload.streamId
                                ? { ...stream, ...action.payload.stream }
                                : stream,
                        ),
                    };
                }),
            };
        default:
            return state;
    }
};
